
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { TUser } from 'src/app/project/modules/user/user.model';

import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../user/user.service';

import { WindowService } from '@core/services';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventUserDropdown,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { EStore } from 'src/app/project/shared/enums/store.enum';
import { EIconPath } from '../../../shared/enums/icons.enum';

@Component({
    selector: 'pp-user-menu-dropdown',
    templateUrl: './user-menu-dropdown.component.html',
    styleUrls: ['./user-menu-dropdown.component.scss'],
    standalone: false
})
export class UserMenuDropdownComponent implements OnInit {
  user$: Observable<TUser>;
  user: TUser;
  cookiesEnabled = false;
  EIconPath = EIconPath;

  constructor(
    private store: Store<{ user: TUser }>,
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private dropdownService: DropdownService,
    private windowService: WindowService,
  ) {
    this.user$ = this.store.pipe(select(EStore.USER));
  }

  ngOnInit() {
    this.cookiesEnabled = !!this.windowService.getCookiehub();
  }

  logout(): void {
    this.authService.logout();

    this.hideDropdown();
  }

  hideDropdown(routerLink: string = null): void {
    this.user = this.userService.getUser();
    this.dropdownService.hideDropdown();

    if (routerLink) {
      if (routerLink === '/settings/user') {
        logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__PROFILE_SETTINGS, {
          source: EGoogleEventCategory.USER_DROPDOWN,
        });
        this.router.navigate([routerLink]);
      } else if (routerLink === '/settings/account') {
        routerLink += '/' + this.user.accountId + '/sites';

        logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__ACCOUNT_SETTINGS, {
          source: EGoogleEventCategory.USER_DROPDOWN,
        });

        this.router.navigate([routerLink]);
      } else if (routerLink === 'contact') {
        logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__CONTACT, {
          source: EGoogleEventCategory.USER_DROPDOWN,
        });
      }
    }
  }

  openCookiesSettings(): void {
    logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__COOKIES, {
      source: EGoogleEventCategory.USER_DROPDOWN,
    });

    this.windowService.getCookiehub().openSettings();
  }

  openHelpCentre(): void {
    logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__HELP, {
      source: EGoogleEventCategory.USER_DROPDOWN,
    });

    this.windowService.open('https://intercom.help/pinpointworks');
  }

  openChangelog(): void {
    logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__CHANGELOG, {
      source: EGoogleEventCategory.USER_DROPDOWN,
    });

    this.windowService.open(
      'https://intercom.help/pinpointworks/en/collections/10431261-what-s-new',
    );
  }

  openUpgradePage(): void {
    logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN__UPGRADE, {
      source: EGoogleEventCategory.USER_DROPDOWN,
    });

    this.windowService.open(
      'https://intercom.help/pinpointworks/en/articles/9853714-add-on-features-timeline-reminders',
    );
  }

  openHiring(): void {
    logEventInGTAG(EGoogleEventUserDropdown.USER_DROPDOWN_HIRING, {
      source: EGoogleEventCategory.USER_DROPDOWN,
    });

    this.windowService.open('https://www.pinpointworks.com/hiring');
  }
}
